var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAcceptedProjectsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-accepted-2150614",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.648,
    height: 18.575,
    viewBox: "0 0 18.648 18.575",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8461",
    "data-name": "Group 8461"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9632",
    "data-name": "Path 9632",
    d: "M15.2,6.063a9.288,9.288,0,1,0,9.321,9.288A9.315,9.315,0,0,0,15.2,6.063Zm0,.813A8.475,8.475,0,1,1,6.773,15.35,8.458,8.458,0,0,1,15.2,6.875Zm4.73,4.783a.423.423,0,0,0-.251.126l-6.46,6.236-2.49-2.49a.423.423,0,1,0-.595.6l2.781,2.781a.423.423,0,0,0,.595.007l6.758-6.526a.423.423,0,0,0-.337-.733Z",
    transform: "translate(-5.875 -6.063)",
    fill: "#68b4ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptedProjectsIcon);
export default __webpack_public_path__ + "static/media/accepted-projects-icon.6b73323bb3acbaf6e944ab9b25dbe975.svg";
export { ForwardRef as ReactComponent };